export default function hasTrackingNumberChanged(
  trackingNumber: string,
  loadedTrackingNumber?: string | null
): boolean {
  return trackingNumber !== (loadedTrackingNumber || "");
}
